import React from "react";
import { Table, Row, Col, Popconfirm, notification, message } from "antd";
import { withRouter } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { axiosInstance } from "../../../commons/commons";
import { unitHandoverVacating } from "../../../constants/url";
import { decodedToken, stateStore } from "../../../constants/constants";

class UnitHandoverVacatingView extends React.Component {
  state = {
    tableData: {
      list: [],
      loading: true,
      currentPage: 1,
      pageSize: 20,
      total: 20,
    },
  };

  columns = [
    {
      title: "S.N",
      dataIndex: "SN",
      key: "SN",
      align: "center",
      fixed: "left",
      width: 50,
      sorter: (a, b) => a.SN - b.SN,
    },
    {
      title: "SysCode",
      dataIndex: "SysCode",
      key: "SysCode",
      align: "center",
      width: 100,
      sorter: (a, b) => a.SysCode.localeCompare(b.SysCode),
    },
    {
      title: "Project",
      dataIndex: "Project",
      key: "Project",
      align: "center",
      width: 100,
      sorter: (a, b) => a.Project.localeCompare(b.Project),
    },
    {
      title: "Building",
      dataIndex: "Building",
      key: "Building",
      align: "center",
      width: 100,
      sorter: (a, b) => a.Building.localeCompare(b.Building),
    },
    {
      title: "Unit",
      dataIndex: "UnitNo",
      key: "UnitNo",
      align: "center",
      width: 100,
      sorter: (a, b) => a.UnitNo.localeCompare(b.UnitNo),
    },
    {
      title: "Customer",
      dataIndex: "Customer",
      key: "customer",
      align: "center",
      width: 100,
      sorter: (a, b) => a.Customer.localeCompare(b.Customer),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      width: 80,
      render: (_, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <EditOutlined
              style={{ color: "#1890ff" }}
              onClick={() => {
                if (
                  decodedToken.value.User_ID !== 1 &&
                  stateStore.permissions[74] &&
                  stateStore.permissions[74].UEdit === "N"
                )
                  return message.warning(
                    "No permission to perform this action!"
                  );
                if (stateStore.navAble)
                  stateStore.navAble({
                    defaultSelectedKeys: ["handoverVacating"],
                    routableProps: {
                      state: { CSRID: item.CSRID },
                    },
                  });
              }}
            />
            <Popconfirm
              title="Are you sure to delete ?"
              onConfirm={(e) => {
                axiosInstance
                  .delete(unitHandoverVacating + "/" + item.CSRID)
                  .then((res) => {
                    if (res.data.success)
                      notification.success({
                        duration: 3,
                        message: "Success",
                        description: res.data.message || "Done!",
                      });
                    else
                      notification.success({
                        duration: 3,
                        message: "Fail",
                        description:
                          res.data.message || "Something went wrong!",
                      });
                    this.getInitialState().then((st) => {
                      this.resetFields();
                      this.setState(st);
                    });
                  })
                  .catch(() => {});
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  getInitialState = async () => {
    let state = {
      tableData: {
        list: this.state.tableData.list,
        loading: false,
        currentPage: this.state.tableData.currentPage,
        pageSize: this.state.tableData.pageSize,
        total: this.state.tableData.total,
      },
    };
    await axiosInstance
      .get(
        unitHandoverVacating +
          "?offset=" +
          (state.tableData.currentPage - 1) * state.tableData.pageSize +
          "&limit=" +
          state.tableData.pageSize
      )
      .then((res) => {
        if (res.data.success) {
          state.tableData.total = res.data.message.count;
          state.tableData.list = res.data.message.rows.map((data, index) => {
            data.SN =
              (state.tableData.currentPage - 1) * state.tableData.pageSize +
              1 +
              index;
            data.key = index;
            return data;
          });
        }
      })
      .catch(() => {});
    return state;
  };

  componentDidMount() {
    this._isMounted = true;
    this.getInitialState().then((st) =>
      this._isMounted ? this.setState(st) : null
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Row style={{ margin: "10px 10px 10px 10px" }}>
          <Col span={4}></Col>
          <Col span={16} style={{ textAlign: "center" }}>
            <h3>Handover Vacating</h3>
          </Col>
          <Col span={4} style={{ textAlign: "right" }}></Col>
        </Row>
        <Row>
          <Col>
            <Table
              loading={this.state.tableData.loading}
              dataSource={this.state.tableData.list}
              columns={this.columns}
              scroll={{ y: window.innerHeight - 270 }}
              pagination={{
                size: "small",
                disabled: false,
                pageSize: this.state.tableData.pageSize,
                showQuickJumper: true,
                showSizeChanger: true,
                // total: this.state.tableData.list.length,
                total: this.state.tableData.total,
                onChange: (page, pageSize) => {
                  let state = this.state;
                  /**
                   * prevents reloading data and displaying 'records found!' message
                   * whenever column filter is applied
                   */
                  if (
                    state.tableData.currentPage === page &&
                    state.tableData.pageSize === pageSize
                  )
                    return;
                  state.tableData.currentPage = page;
                  state.tableData.pageSize = pageSize;
                  state.tableData.loading = true;
                  this.setState(state, () =>
                    this.getInitialState().then((state) => this.setState(state))
                  );
                },
              }}
            ></Table>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(UnitHandoverVacatingView);
